module.exports = __webpack_public_path__ + "img/booking-deliveries.c1556e9a.svg";